import BasePointTagManager from "../../../../../src/managers/BasePointTagManager";
import { Coord } from "../../../../../src/types/Interface";


export default class PointTagManager extends BasePointTagManager {
    constructor(cCoord: Coord) {
        super(cCoord, [])
    }
}